import { appData } from "@/mocks/homeData";

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-lg border border-background-200/50 p-6 md:p-8 flex flex-col md:flex-row items-center gap-6 md:gap-10">
          <div className="w-40 h-64 md:w-48 md:h-72 flex-shrink-0 rounded-lg overflow-hidden">
            <img
              src={appData.image}
              alt="天美麻花星空影视移动端"
              className="w-full h-full object-cover object-top"
              onError={(e) => {
                (e.currentTarget.parentElement as HTMLElement).style.display = "none";
              }}
            />
          </div>
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-lg md:text-2xl font-heading text-foreground-50 mb-3">{appData.title}</h2>
            <p className="text-foreground-500 text-sm leading-relaxed mb-4">{appData.desc}</p>
            <div className="flex flex-wrap gap-2 justify-center md:justify-start">
              {appData.features.map((feat) => (
                <span
                  key={feat}
                  className="px-3 py-1.5 bg-secondary-100/50 text-secondary-300 text-xs rounded-full whitespace-nowrap"
                >
                  {feat}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}